export interface PainPoint {
  title: string
  lines: string[]
}

export const painPoints: PainPoint[] = [
  {
    title: '😰 TROP D’INFORMATIONS, MAIS AUCUN PARCOURS CLAIR...',
    lines: [
      'Une vidéo explique les capteurs. Une autre parle de Zigbee. Un tutoriel présente Home Assistant. Puis vous découvrez Matter. Thread. Les hubs. Les passerelles. Les automatisations. Jeedom. Google Home. Apple Home.',
      'Le problème n’est pas de trouver des informations. Le problème est de savoir quoi apprendre en premier, ce qui vient ensuite et comment tout réunir dans un véritable projet.',
      'Au lieu de suivre une progression... Vous passez constamment d’un sujet à l’autre.',
    ],
  },
  {
    title: '⚠️ COMPATIBILITÉ, PROTOCOLES ET APPAREILS DEVIENNENT VITE COMPLEXES',
    lines: [
      'Wi-Fi. Bluetooth. Zigbee. Z-Wave. Thread. Matter. Hub. Bridge. Passerelle. Des dizaines d’appareils promettent de rendre votre maison plus intelligente.',
      'Mais acheter un appareil est facile. Comprendre s’il convient à votre projet, s’il communique avec vos autres équipements et comment l’intégrer correctement est une autre histoire.',
      'Un mauvais choix peut entraîner des appareils incompatibles, plusieurs applications différentes et des automatisations qui ne fonctionnent pas comme prévu.',
    ],
  },
  {
    title: '🏠 VOUS NE SAVEZ PAS COMMENT PASSER DE L’IDÉE À L’INSTALLATION',
    lines: [
      'Savoir ce qu’est un capteur ne suffit pas. Connaître Matter ne suffit pas. Regarder quelqu’un configurer une maison connectée sur YouTube ne signifie pas savoir en concevoir une.',
      'Quelles pièces faut-il analyser ? Où placer les appareils ? Quel protocole utiliser ? Comment organiser les pièces et les zones ? Quelles automatisations sont réellement utiles ? Comment vérifier que tout fonctionne ?',
      'Sans méthode progressive... Il est facile d’accumuler des connaissances sans réussir à les transformer en système concret.',
    ],
  },
  {
    title: '😩 ET QUAND QUELQUE CHOSE NE FONCTIONNE PAS, TOUT SE COMPLIQUE',
    lines: [
      'Un capteur ne répond plus. Un appareil refuse de s’appairer. Une automatisation ne se déclenche pas. Le réseau couvre mal une pièce. Un appareil nécessite une passerelle que vous n’aviez pas prévue. Deux écosystèmes ne communiquent pas comme prévu.',
      'Connaître les appareils individuellement n’est pas suffisant. Disposer d’une méthode pour concevoir, installer, configurer, tester et résoudre les problèmes fait toute la différence.',
    ],
  },
]
